import { useToast } from "components/atoms/toast/toast-context";
import { FormGroupField } from "components/web-checkout/form-group/form-group";
import { LoginBackground } from "components/web-checkout/login-background/login-background";
import { useAddLocation } from "hooks/pages/use-add-location/use-add-location";
import { useUserValidation } from "hooks/pages/use-user-validation/use-user-validation";
import Image from "next/legacy/image";
import { useRouter } from "next/router";
import ActiveLocationIcon from "public/assets/location-details/active-location.svg";
import ActiveSearchIcon from "public/assets/location-details/active-search.svg";
import InfoIcon from "public/assets/location-details/info-icon.svg";
import LocationIcon from "public/assets/location-details/location.svg";
import SearchIcon from "public/assets/search.svg";
import { useState } from "react";
import { Card } from "styles/pages/web-checkout.styles";
import { containsNonASCII } from "utils/utils";
import {
  CardHeading,
  CompleteProfile,
  CompleteProfileWrapper,
  InfoBanner,
  InfoIconWrapper,
  InfoText
} from "../../../styles/pages/register/location-details.styles";

const AddLocationPage = () => {
  const [residence, setResidence] = useState("");
  const [school, setSchool] = useState("");
  const router = useRouter();
  const { addToast } = useToast();
  const { locationErrors, validateLocationData } = useUserValidation();

  const {
    cityOptions,
    schoolOptions,
    isCustomCity,
    isCustomSchool,
    isFormValid,
    primaryUser,
    updateLocalUserData
  } = useAddLocation({
    city: residence,
    school
  });

  const handleSubmit = () => {
    if (!isFormValid) return;
    if (!validateLocationData({ residence, schoolName: school })) return;
    if (containsNonASCII({ residence, school })) {
      addToast({
        heading:
          "Beberapa karakter yang kamu masukkan tidak didukung. Silakan coba lagi dengan teks biasa",
        variant: "error"
      });
      return;
    }
    updateLocalUserData(residence, school);
    router.push("/user/register/user-details");
  };

  return (
    <LoginBackground routerPath="/user/register/add-location">
      <Card>
        <CardHeading>
          Hai {primaryUser?.full_name}! lengkapi profilmu yuk 😉
        </CardHeading>

        <InfoBanner>
          <InfoIconWrapper>
            <Image src={InfoIcon} width="20" height="20" alt="info-icon" />
          </InfoIconWrapper>
          <InfoText>
            Profilmu udah dibuat pas kamu beli paket di CoLearn, tinggal
            lengkapin dikit aja kok
          </InfoText>
        </InfoBanner>

        <FormGroupField
          label="Tempat tinggal"
          placeholder="Contoh: Jakarta"
          value={residence}
          changeHandler={setResidence}
          options={cityOptions}
          isCustom={isCustomCity}
          activeIcon={ActiveLocationIcon}
          inactiveIcon={LocationIcon}
          margin="0 0 20px 0"
          errorMessage={locationErrors["residence"]}
        />

        <FormGroupField
          label="Nama sekolah"
          placeholder="Contoh: SMAN 1 Jakarta"
          value={school}
          changeHandler={setSchool}
          options={schoolOptions}
          isCustom={isCustomSchool}
          notFoundMessage="Pastikan nama sekolahmu benar, ya"
          activeIcon={ActiveSearchIcon}
          inactiveIcon={SearchIcon}
          errorMessage={locationErrors["schoolName"]}
          isSchoolField={true}
        />

        <CompleteProfileWrapper>
          <CompleteProfile
            disabled={!isFormValid}
            type="submit"
            variant="primary"
            onClick={handleSubmit}
          >
            Lengkapi profil
          </CompleteProfile>
        </CompleteProfileWrapper>
      </Card>
    </LoginBackground>
  );
};

AddLocationPage.requireAuth = true;
export default AddLocationPage;
